var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Home"}},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"main_left"},_vm._l((_vm.indexGame),function(it,i){return _c('GameCell',{key:i,staticClass:"left_list",attrs:{"dataSource":it},on:{"needGetData":_vm.handleGetData}})}),1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5853072c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home/index.vue
// module id = null
// module chunks = 